/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SourceSystem = {
    CASHBOX: 'CASHBOX',
    CALLCENTER: 'CALLCENTER',
    WHATSAPP: 'WHATSAPP',
    INSTAGRAM: 'INSTAGRAM',
    KIOSK: 'KIOSK',
    MANAGER: 'MANAGER',
    ONLINE: 'ONLINE',
    ONLINE_APP: 'ONLINE_APP',
    WEBKASSA: 'WEBKASSA',
    QUEUE: 'QUEUE',
    DELIVERY: 'DELIVERY',
    VANILLA: 'VANILLA',
    SUPPLIER: 'SUPPLIER',
    TELEGRAM: 'TELEGRAM',
    CONFECTIONARY: 'CONFECTIONARY'
} as const;
export type SourceSystem = typeof SourceSystem[keyof typeof SourceSystem];

